export default __webpack_public_path__ + "static/media/blog.97d9765b.svg";